<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
      name: 'App',
      data () {
          return {
             
          }
      },
      created(){
        // if(this.isMobile()){
        //   location.href='/h5?s=pc';
        // }
      },
      methods:{
        isMobile() {
          let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          );
          return flag;
        },

      }
  }
  </script>

<style>
  html,
body {
    overflow-y: auto !important;
    overflow-x: hidden;
    box-sizing: border-box;
    padding: 0px !important;
    margin: 0px;
    height: 100vh;
    background-image: url('@/assets/bg.jpg');
    background-position: center center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-color: #080808;
    background-size: cover;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.bg_test{
  background-color: #ccc;
}
.image_btn{
  cursor: pointer;
}
.image_btn:hover{
  opacity: 0.8;
}
.image_btn:active{
  transform: translateY(2px);
}
.page_fy{
  margin-top: 15px;
}
.body_con h1{
  color: #9e9d9d;
}
.body_con{
  margin:20px auto;
  width:1200px;
  margin-top:90px;
}
.clear_both{
  width: 100%;
  height: 20px;
  clear: both;
}
.el-table__body-wrapper {
  overflow-y: scroll !important;
}
.table_header th.el-table__cell{
  background-color: #f6f6f6 !important;
}
.table_con{
  width: 95%;
  margin:0 auto;
  min-height: 300px;
}
.el-table tr.warning-row>td.el-table__cell{
  background-color: #fef3aa !important;
}
.el-table tr.warning-row.hover-row>td.el-table__cell{
  background-color: #fef3aa !important;
}
.el-menu.el-menu--horizontal{
  border:none;
}
.el-button:hover{
  opacity: 0.8;
}
.color_white{
  color:#fff;
}
.btn-layout1:hover{
  opacity: 0.8;
}
.btn-layout1:active{
  transform: translateY(2px);
}
.btn-layout1 {
  cursor: pointer;
  padding: 10px 10px;
  font-size: 15px;
  font-weight: bold;
  color: #000;
  border: none;
  border-radius: 12px;
  background: linear-gradient(180deg, #b8e066 0%, #88b833 50%, #558822 100%);
  box-shadow:
    inset 0 2px 6px rgba(255,255,255,0.6),
    inset 0 -2px 6px rgba(0,0,0,0.3),
    0 0 12px rgba(136, 184, 51, 0.8),
    0 4px 8px rgba(0,0,0,0.5);
  text-shadow: 0 0 4px rgba(184, 224, 102, 0.8);
}
.btn-layout1.btn_lay_black{
  background: linear-gradient(180deg, #555555 0%, #333333 50%, #111111 100%);
  box-shadow:
    inset 0 2px 6px rgba(255,255,255,0.6),
    inset 0 -2px 6px rgba(0,0,0,0.3),
    0 0 12px rgba(85, 85, 85, 0.8),
    0 4px 8px rgba(0,0,0,0.5);
  text-shadow: 0 0 4px rgba(85, 85, 85, 0.8);
  color:#ccc;
}
</style>
